export default __webpack_public_path__ + "static/media/LeftOneButton.78a71ca9.webp";